var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.75C0.5 0.335786 0.835786 0 1.25 0H14.75C15.1642 0 15.5 0.335786 15.5 0.75C15.5 1.16421 15.1642 1.5 14.75 1.5H1.25C0.835787 1.5 0.5 1.16421 0.5 0.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 0C0.835786 0 0.5 0.335786 0.5 0.75C0.5 1.16421 0.835787 1.5 1.25 1.5H14.75C15.1642 1.5 15.5 1.16421 15.5 0.75C15.5 0.335786 15.1642 0 14.75 0H1.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.25C0.5 14.8358 0.835786 14.5 1.25 14.5H14.75C15.1642 14.5 15.5 14.8358 15.5 15.25C15.5 15.6642 15.1642 16 14.75 16H1.25C0.835787 16 0.5 15.6642 0.5 15.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 14.5C0.835786 14.5 0.5 14.8358 0.5 15.25C0.5 15.6642 0.835787 16 1.25 16H14.75C15.1642 16 15.5 15.6642 15.5 15.25C15.5 14.8358 15.1642 14.5 14.75 14.5H1.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00765 7.25C7.80874 7.25023 7.61788 7.17142 7.47707 7.03093L4.47027 4.03093C4.17705 3.73837 4.17651 3.2635 4.46907 2.97027C4.76163 2.67705 5.2365 2.67651 5.52973 2.96907L8.0056 5.43934L10.4691 2.97027C10.7616 2.67705 11.2365 2.67651 11.5297 2.96907C11.823 3.26163 11.8235 3.7365 11.5309 4.02973L8.53773 7.02973C8.39724 7.17054 8.20657 7.24977 8.00765 7.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46967 8.96967C7.76256 8.67678 8.23744 8.67678 8.53033 8.96967L11.5303 11.9697C11.8232 12.2626 11.8232 12.7374 11.5303 13.0303C11.2374 13.3232 10.7626 13.3232 10.4697 13.0303L8 10.5607L5.53033 13.0303C5.23744 13.3232 4.76256 13.3232 4.46967 13.0303C4.17678 12.7374 4.17678 12.2626 4.46967 11.9697L7.46967 8.96967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.162b08ff.svg";
export { ForwardRef as ReactComponent };